import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CommentsService } from '@eview/core/services/comments.service';
import {
  CreateComments,
  CreateCommentsFailure,
  CreateCommentsSuccess,
  DeleteComment,
  DeleteCommentFailure,
  DeleteCommentSuccess,
  ECommentsActions,
  GetCommentsData,
  GetCommentsFailure,
  GetCommentsSuccess
} from '../actions/comment.actions';

@Injectable()
export class CommentsEffects {
  constructor(private commentsServices: CommentsService) {}

  private readonly actions$ = inject(Actions);

  createComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CreateComments>(ECommentsActions.CreateComments),
      switchMap(action =>
        this.commentsServices.createComments(action.payload).pipe(
          map(result => (result ? new CreateCommentsSuccess() : new CreateCommentsFailure())),
          catchError(() => of(new CreateCommentsFailure()))
        )
      )
    )
  );

  getComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetCommentsData>(ECommentsActions.GetCommentsData),
      map(action => action.payload),
      switchMap(payload =>
        this.commentsServices.getComments(payload).pipe(
          map(result => (result ? new GetCommentsSuccess(result) : new GetCommentsFailure())),
          catchError(() => of(new GetCommentsFailure()))
        )
      )
    )
  );

  deleteComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeleteComment>(ECommentsActions.DeleteComment),
      map(action => action.payload),
      switchMap(payload =>
        this.commentsServices.deleteComments(payload).pipe(
          map(result => (result ? new DeleteCommentSuccess() : new DeleteCommentFailure())),
          catchError(() => of(new DeleteCommentFailure()))
        )
      )
    )
  );
}
